const en = {
  banner: {
    title: 'Lose Weight Smart',
    subtitle: 'Natural fat burner that helps you reach your goal',
    cta: 'Choose Your Pack',
    slide1: 'Visible results in 10 days',
    slide2: 'Stop Injecting Ozempic',
    slide3: 'Feel the energy, not the hunger',
  }
  ,
  about: {
    title: 'How It Works',
    description: 'Our capsules boost your metabolism and reduce appetite without side effects.',
    feature1: 'Natural ingredients',
    feature2: 'Fast results',
    feature3: 'Safe and certified',
  },
  buy: {
    title: 'Pick Your Plan',
    pack1: '10 capsules',
    pack2: '30 capsules',
    pack3: '100 capsules',
    cta: 'Buy Now',
  },
  faq: {
    title: 'Questions & Answers',
    q1: 'How safe is the product?',
    a1: 'This medical product has been tested and is completely safe when taken according to dosage and contraindications.',
    q2: 'How often should the medicine be taken?',
    a2: 'Take once a day, strictly on an empty stomach, one hour before breakfast. Do not take in the afternoon to avoid sleep issues.',
    q3: 'Who is the manufacturer of the product?',
    a3: 'The manufacturer and supplier is Lannet, USA.',
    q4: 'Where can I read the official instructions?',
    a4: 'You can find the official instructions on the manufacturer’s website.',
    q5: 'What are the first sensations after taking a capsule?',
    a5: 'After 20–30 minutes, you’ll feel a boost of energy and reduced hunger for a long time.',
    q6: 'How does payment and delivery work?',
    a6: 'You can pay via bank transfer or cash on delivery at your preferred postal service.',
    q7: 'Will I become addicted to the product?',
    a7: 'If taken correctly according to the manufacturer’s instructions, the product does not cause addiction after the treatment course.',
  },  
  contact: {
    title: 'Order / Contact',
    name: 'Your name',
    email: 'Your email',
    phone: 'Your phone',
    message: 'Message or order details',
    send: 'Send',
    success: '✅ Request sent successfully!',
    error: '❌ Failed to send. Please try again later.',
    notify: 'New request from Body Harmony website',
  },
  
}

export default en
